module.exports = __webpack_public_path__ + "static/img/qrd.4211696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/qrd.png
// module id = 171
// module chunks = 1